import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import DownloadsTableRowMenu from './DownloadsTableRowMenu';

import classes from './DownloadsTable.module.css';

const DownloadsTable = ({
    downloads,
    companyInfo,
    isFullHubAllowed,
    ...props
}) => {
    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.headerCell}>
                        Download
                    </TableCell>
                    <TableCell padding="none" />
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                        <span>Gateway Manager</span>
                    </TableCell>
                    <TableCell
                        className={classes.rowMenuCell}
                        padding="none"
                    >
                        <DownloadsTableRowMenu
                            isGatewayManagerDownload={true}
                        />
                    </TableCell>
                </TableRow>
                {
                    process.env.erpAgentEnabled &&
                    <TableRow>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <span>Signature Agent</span>
                        </TableCell>
                        <TableCell
                            className={classes.rowMenuCell}
                            padding="none"
                        >
                            <DownloadsTableRowMenu
                                isErpAgentInstallerDownload={true}
                            />
                        </TableCell>
                    </TableRow>
                }
                <TableRow
                    classes={{
                        root: classes.hideRow
                    }}
                >
                    <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                        <span>Software BAS Agent</span>
                    </TableCell>
                    <TableCell
                        className={classes.rowMenuCell}
                        padding="none"
                    >
                        <DownloadsTableRowMenu
                            companyInfo={companyInfo}
                            isBasAgentDownload={true}
                        />
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

DownloadsTable.defaultProps = {
    isFullHubAllowed: true
};

DownloadsTable.propTypes = {

};

export default DownloadsTable;
